import { CustomFileInfoCard } from "./CustomFileInfoCard";

import { UploadFileType } from "@type/HRM/upload-file";

export const FileViewOnlyCard = ({
  data,
  largeCol,
}: {
  data: UploadFileType[];
  largeCol?: boolean;
}) => {
  return (
    <div className="d-flex flex-column gap-8">
      {data.map((doc: UploadFileType) => (
        <CustomFileInfoCard
          key={doc.id}
          id={doc.id}
          fileName={doc.name}
          fileType={doc.documentType}
          documentId={doc.documentId}
          fileId={doc.fileId}
          doc={doc}
          disabled
          viewOnly
          largeCol={largeCol}
        />
      ))}
    </div>
  );
};
